import Axios from "axios";
import { action, decorate, observable } from "mobx";
import LocalGridConfig from "../../../../config/LocalGridConfig";
import { isBillingJobstatus } from "../../../../utils/GlobalFunction";
import moment from "moment";
import { Constant } from "../../../../config/Constant";

export default class ManageDeliveryInvoiceJobStore {
    agGrid = null;
    agGridBillingRequests = null;
    agGridBillingNotRequests = null;
    per_page = LocalGridConfig.options.paginationPageSize;
    current_page = 1;
    list_data = null;
    total = 0;
    allColumnIds = [];
    deleteValues = null;
    createJobValues = null
    startEndDate = null
    viewValues = null;
    businessValues = null
    editValues = null;
    editBusinessValues = null;
    fromToDate = moment().subtract(1, 'month')
    dateRange = moment().format(Constant.DEFAULT_MONTH_YEAR_FORMAT)
    findHub = null;
    selectedFinalizedData = null

    setSelectedFinalizedData = (data) => {
        this.selectedFinalizedData = data;
    };
    setFromToDate = (data) => {
        this.fromToDate = data;
    };
    setDateRange = (data) => {
        this.dateRange = data.format(Constant.DEFAULT_MONTH_YEAR_FORMAT);
    };
    setFindHub = (data) => {
        this.findHub = data;
    };
    // Setup grid and set column size to autosize
    setupGrid = (params) => {
        this.agGrid = params;
    };

    // set form values to edit
    setEditValues = (data) => {
        this.editValues = data;
    };

    // set form values to edit
    setEditBusinessValues = (data) => {
        this.editBusinessValues = data;
    };
    // Billing Requests Setup grid and set column size to autosize
    setupGridBillingRequests = (params) => {
        this.agGridBillingRequests = params;
    };

    // Billing not Requests Setup grid and set column size to autosize
    setupGridBillingNotRequests = (params) => {
        this.agGridBillingNotRequests = params;
    };

    // set form values to delete
    setDeleteValues = (data) => {
        this.deleteValues = data;
    };

    // set form values to View
    setViewValues = (data) => {
        this.viewValues = data;
    };

    // set form values to business
    setBusinessValues = (data) => {
        this.businessValues = data;
    };

    // set form values to delete
    setCreateJobeValues = (data) => {
        this.createJobValues = data;
    };

    setStartEndDate = (data) => {
        this.startEndDate = data;
    };

    // change page size, default page size is LocalGridConfig.options.paginationPageSize
    setPageSize = (page = this.per_page) => {
        this.per_page = page;
        if (this.agGrid) {
            this.agGrid.api.paginationSetPageSize(parseInt(page));
        }
    };

    // change page size, default page size is LocalGridConfig.options.paginationPageSize
    setPageSizeBillingJobRequests = (page = this.per_page) => {
        this.per_page = page;
        if (this.agGridBillingRequests) {
            this.agGridBillingRequests.api.paginationSetPageSize(parseInt(page));
        }
    };
    // change page size, default page size is LocalGridConfig.options.paginationPageSize
    setPageSizeBillingJobNotRequests = (page = this.per_page) => {
        this.per_page = page;
        if (this.agGridBillingNotRequests) {
            this.agGridBillingNotRequests.api.paginationSetPageSize(parseInt(page));
        }
    };

    refreshList = () => {
        if (this.agGrid) {
            this.setupGrid(this.agGrid);
        }
    }

    refreshRequestJobsList = () => {
        if (this.agGridBillingRequests) {
            this.setupGridBillingRequests(this.agGridBillingRequests);
        }
    }
    refreshNotRequestJobsList = () => {
        if (this.agGridBillingNotRequests) {
            this.setupGridBillingNotRequests(this.agGridBillingNotRequests);
        }
    }

    jobCreateBySpecificHubLocation = (data) => {
        return Axios.post(`/ho-activities/delivery-invoice-job/create-for-center`, data)
            .then(({ data }) => {
                return data;
            })
            .catch(({ response: { data } }) => {
                var errors = [];
                var notify = null;
                const { NOTIFICATION, ...fieldErrors } = data.STATUS;
                if (data && data.STATUS) {
                    if (NOTIFICATION) {
                        notify = NOTIFICATION[0];
                    }
                    Object.keys(fieldErrors).forEach((name) => {
                        errors.push({ name, errors: data.STATUS[name] });
                    });
                }
                return Promise.reject({ errors, notify });
            });
    };

    HOBillingRequestsGetList = (data) => {
        if (this.agGridBillingRequests) {
            var filter = this.agGridBillingRequests.api.getFilterModel();
            var sort = this.agGridBillingRequests.api.getSortModel();
        }
        this.list_data = null;
        return Axios.post(`/ho-activities/delivery-invoice-job/list`, data).then(({ data }) => {
            this.setStartEndDate([data.start, data.end])
            if (data.list.length) {
                data.list.map((item, index) => {
                    item.srno = index + 1;
                    item.is_status = isBillingJobstatus[item.status]
                    return null;
                });
            }
            this.list_data = data.list ? data.list : null;
            this.total = data.list.total;
            this.current_page = data.list.current_page;
            var allColumnIds = [];
            if (this.agGridBillingRequests && this.agGridBillingRequests.columnApi) {
                this.agGridBillingRequests.columnApi.getAllColumns().forEach(function (column) {
                    allColumnIds.push(column.colId);
                });
            }
            if (this.agGridBillingRequests) {
                this.agGridBillingRequests.api.setFilterModel(filter);
                this.agGridBillingRequests.api.setSortModel(sort);
            }
        });
    };

    HOBillingNotRequestsGetList = (data) => {
        if (this.agGridBillingNotRequests) {
            var filter = this.agGridBillingNotRequests.api.getFilterModel();
            var sort = this.agGridBillingNotRequests.api.getSortModel();
        }
        this.list_data = null;
        return Axios.post(`/ho-activities/delivery-invoice-job/requested-locations`, data).then(({ data }) => {
            this.setStartEndDate([data.start, data.end])
            if (data.list.length) {
                data.list.map((item, index) => {
                    item.srno = index + 1;
                    item.is_status = isBillingJobstatus[item.status]
                    return null;
                });
            }
            this.list_data = data.list ? data.list : null;
            this.total = data.list.total;
            this.current_page = data.list.current_page;
            var allColumnIds = [];
            if (this.agGridBillingNotRequests && this.agGridBillingNotRequests.columnApi) {
                this.agGridBillingNotRequests.columnApi.getAllColumns().forEach(function (column) {
                    allColumnIds.push(column.colId);
                });
            }
            if (this.agGridBillingNotRequests) {
                this.agGridBillingNotRequests.api.setFilterModel(filter);
                this.agGridBillingNotRequests.api.setSortModel(sort);
            }
        });
    };

    // Call delete api
    DeleteDeliveryBillingRequest = (formData, openFrom) => {
        return Axios.post(`/ho-activities/delivery-invoice-job/cancellation`, formData)
            .then(({ data }) => {
                if (openFrom === "DeliveryBillingJobsView" || openFrom === "BillingJobList") {
                    this.HOBillingJobsGetList();
                }
                else {
                    this.HOBillingRequestsGetList({ from_to_date: this.dateRange, hub_id: this.findHub });
                }
                return data;
            })
            .catch((response) => {
                return Promise.reject(response);
            });
    };

    // call api to get records
    BusinessViewData = (data) => {
        return Axios.get(`/ho-activities/delivery-invoice-job/preview-confirm-business/${data.id}`).then(({ data }) => {
            this.setBusinessValues(data.preview);
            return data;
        });
    };

    // Call delete api
    BusinessDataConfirm = (formData, openFrom) => {
        return Axios.post(`/ho-activities/delivery-invoice-job/confirm-business`, formData)
            .then(({ data }) => {
                if (openFrom === "DeliveryBillingJobsView") {
                    this.HOBillingJobsGetList();
                }
                this.HOBillingRequestsGetList({ from_to_date: this.dateRange, hub_id: this.findHub });
                return data;
            })
            .catch((response) => {
                return Promise.reject(response);
            });
    };

    doFinalization = (formData) => {
        return Axios.post(`/ho-activities/delivery-invoice-job/finalization`, formData)
            .then(({ data }) => {
                this.agGridBillingRequests.api.deselectAll();
                this.HOBillingRequestsGetList({ from_to_date: this.dateRange, hub_id: this.findHub });
                return data;
            })
            .catch(({ response: { data } }) => {
                var errors = [];
                var notify = null;
                const { NOTIFICATION, ...fieldErrors } = data.STATUS;
                if (data && data.STATUS) {
                    if (NOTIFICATION) {
                        notify = NOTIFICATION[0];
                    }
                    Object.keys(fieldErrors).forEach((name) => {
                        errors.push({ name, errors: data.STATUS[name] });
                    });
                }
                return Promise.reject({ errors, notify });
            });
    };

    // Filter function for no record found message
    onFilterChanged = (params) => {
        this.agGrid = params;
        if (this.agGrid && this.agGrid.api.getModel().getRowCount() === 0) {
            this.agGrid.api.showNoRowsOverlay();
        }
        if (this.agGrid && this.agGrid.api.getModel().getRowCount() > 0) {
            this.agGrid.api.hideOverlay();
        }
    };
    onBillingRequestsFilterChanged = (params) => {
        if (this.agGridBillingRequests && this.agGridBillingRequests.api.getModel().getRowCount() === 0) {
            this.agGridBillingRequests.api.showNoRowsOverlay();
        }
        if (this.agGridBillingRequests && this.agGridBillingRequests.api.getModel().getRowCount() > 0) {
            this.agGridBillingRequests.api.hideOverlay();
        }
    };
    onBillingNotRequestsFilterChanged = (params) => {
        if (this.agGridBillingNotRequests && this.agGridBillingNotRequests.api.getModel().getRowCount() === 0) {
            this.agGridBillingNotRequests.api.showNoRowsOverlay();
        }
        if (this.agGridBillingNotRequests && this.agGridBillingNotRequests.api.getModel().getRowCount() > 0) {
            this.agGridBillingNotRequests.api.hideOverlay();
        }
    };
}

decorate(ManageDeliveryInvoiceJobStore, {
    per_page: observable,
    agGrid: observable,
    list_data: observable,
    total: observable,
    allColumnIds: observable,
    setupGrid: action,
    setPageSize: action,
    onFilterChanged: action,
    setDeleteValues: action,
    deleteValues: observable,
    setCreateJobeValues: action,
    createJobValues: observable,
    setStartEndDate: action,
    startEndDate: observable,
    setViewValues: action,
    viewValues: observable,
    setupGridBillingRequests: action,
    agGridBillingRequests: observable,
    editValues: observable,
    setEditValues: action,
    setFromToDate: action,
    fromToDate: observable,
    setBusinessValues: action,
    businessValues: observable,
    setPageSizeBillingJobRequests: action,
    editBusinessValues: observable,
    setEditBusinessValues: action,
    setDateRange: action,
    dateRange: observable,
    setFindHub: action,
    findHub: observable,
    setSelectedFinalizedData: action,
    selectedFinalizedData: observable,
});
